import { ref } from 'vue'

const STORAGE_KEY = 'portal.recentVisits'
const MAX_ITEMS = 8

export interface RecentVisit {
  label: string
  path: string
  visitedAt: number
}

function readVisits(): RecentVisit[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return []
    return JSON.parse(raw) as RecentVisit[]
  } catch {
    return []
  }
}

/** 반응형 최근 방문 (대시보드 · 헤더에서 구독) */
export const recentVisits = ref<RecentVisit[]>(readVisits())

export function loadRecentVisits(): RecentVisit[] {
  return readVisits()
}

export function saveRecentVisit(label: string, path: string) {
  if (path === '/' || path.startsWith('/login')) return

  const list = readVisits().filter((item) => item.path !== path)
  list.unshift({ label, path, visitedAt: Date.now() })
  const next = list.slice(0, MAX_ITEMS)
  localStorage.setItem(STORAGE_KEY, JSON.stringify(next))
  recentVisits.value = next
}

/* ----------------- 최근 검색어 ----------------- */
const SEARCH_KEY = 'portal.recentSearches'
const MAX_SEARCHES = 8

function readSearches(): string[] {
  try {
    const raw = localStorage.getItem(SEARCH_KEY)
    if (!raw) return []
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed) ? parsed.filter((v): v is string => typeof v === 'string') : []
  } catch {
    return []
  }
}

export const recentSearches = ref<string[]>(readSearches())

export function addRecentSearch(term: string) {
  const value = term.trim()
  if (!value) return
  const next = [value, ...recentSearches.value.filter((item) => item !== value)].slice(0, MAX_SEARCHES)
  recentSearches.value = next
  localStorage.setItem(SEARCH_KEY, JSON.stringify(next))
}

export function removeRecentSearch(term: string) {
  const next = recentSearches.value.filter((item) => item !== term)
  recentSearches.value = next
  localStorage.setItem(SEARCH_KEY, JSON.stringify(next))
}

export function clearRecentSearches() {
  recentSearches.value = []
  localStorage.removeItem(SEARCH_KEY)
}

/* ----------------- 저장된 아이디 ----------------- */
export const SAVED_USER_ID_KEY = 'portal.savedUserId'

export function loadSavedUserId(): string {
  return localStorage.getItem(SAVED_USER_ID_KEY) ?? ''
}

export function saveSavedUserId(userId: string) {
  if (userId) localStorage.setItem(SAVED_USER_ID_KEY, userId)
  else localStorage.removeItem(SAVED_USER_ID_KEY)
}
